<app-titled-page heading="Plantillas">
  <router-outlet></router-outlet>
</app-titled-page>
